export const DASHBOARD_LIST_INITING         = 'DASHBOARD_LIST_INITING'

export const DASHBOARD_SINHNHAT_LIST_INITING         = 'DASHBOARD_SINHNHAT_LIST_INITING'
export const DASHBOARD_SINHNHAT_LIST_REQUESTING      = 'DASHBOARD_SINHNHAT_LIST_REQUESTING'
export const DASHBOARD_SINHNHAT_LIST_SUCCESS         = 'DASHBOARD_SINHNHAT_LIST_SUCCESS'
export const DASHBOARD_SINHNHAT_LIST_ERROR           = 'DASHBOARD_SINHNHAT_LIST_ERROR'  
 
export const DASHBOARD_SINHNHAT_LIST_API    = '/api/v1/report/dashboard_sinh_nhat_trong_thang'  


// WEBPACK FOOTER //
// ./src/views/Dashboard/constants.js